import '../scss/critical.scss';
//
import './icons';
// Custom components


import languageSwitcher from './components/global/language-swticher'
import newsletter from './components/global/newsletter'
import productTabs from './components/global/product-tabs'
import productFilters from "./components/global/product-filters";
import smartHeader from './components/global/smart-header'
import selector from './components/global/selector'
import htmlFontTransform from "./components/global/html-font-transform";
import cart from "./components/global/cart";

window.addEventListener('DOMContentLoaded', function () {
	let pageBody = document.body
	if (window.globalJS.isNewMenuEnabled && document.querySelector('.navbar__wrapper')) {
		selector()

		smartHeader()
	}
	document.querySelector('.vi-wcaio-sidebar-cart-wrap') &&
	import("./components/global/cart").then(module => {
		cart();
	});

	newsletter()
	productTabs()
	htmlFontTransform()
	productFilters()
})


const initMobileScripts = async () => {
	await import('./mobile.js')
}

const initDesktopScripts = async () => {
	await import('./desktop.js')
}

window.addEventListener('DOMContentLoaded', (e) => {
	if (window.matchMedia("(min-width: 992px)").matches) {
		initDesktopScripts()
	} else {
		initMobileScripts()
	}
})

window.addEventListener('resize', (e) => {
	if (window.matchMedia("(min-width: 992px)").matches) {
		console.log('desktop')
		initDesktopScripts()
	} else {
		console.log('mobile')
		initMobileScripts()
	}
})


